import { findIndex } from "lodash";

import { ItemEdit } from "../../../sales/edit/item-edit/item-edit.service";

export class OnlineItemEdit extends ItemEdit {
    public static $inject: string[] = ["onlinePriceService"];

    public isOnlineOpen: boolean;
    public isEdited: boolean;
    public isPast: boolean;
    public commissionRates: any;

    constructor(
        protected onlinePriceService
    ) {
        super(onlinePriceService);
    }

    public close() {
        this.isOnlineOpen = false;
    }

    public openOnline(itemId: number, { isEdited, isPast } = { isEdited: false, isPast: false }) {
        this.filterItemsArray = this.getFilteredItems();
        this.currentIndex = findIndex(this.filterItemsArray, (item: any) => item.id === itemId);

        this.isEdited = isEdited;
        this.isPast = isPast;

        this._initCurrentItem();
        this._toggleOnline();
    }

    public setCommissionRates(rates: any) {
        this.commissionRates = this.onlinePriceService.setCommissionRates(rates);
    }

    private _toggleOnline() {
        this.isOnlineOpen = !this.isOnlineOpen;
    }
}
